/**
 * created by zhouzt on 2020-05-07
 *
 * description: 正在签署接口地址
 *
 */

const config = require('libs/config.js')

const sign = {
	// 正在签署（询价）列表
	getInquiryList: config.MS_XY_PATH + '/outline/inquiry/queryInquiryByPage',
	// 正在签署（招标）列表
	getTenderList: config.MS_XY_PATH + '/outline/bidding/querySubproject'
}

export default sign



// WEBPACK FOOTER //
// ./src/api/sign/index.js